import styled from 'styled-components';
import primitives from '@veneer/primitives';
import divHTMLRender from '../../../shared/divHTMLRender';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${primitives.layout.size8}px ${primitives.layout.size6}px;
  text-align: center;
`;

// This screens are copied from HPC3.
// We are using the same colors even if they are not in primitives.
// And the font-weight must be manually set to match the HPC3 design.
// TODO: When a official design is ready, we should update the styles to remove these hardcoded values.

export const Title = styled.h1`
  color: #5a5a5a;
  font-weight: ${primitives.typography.weight2};
`;

export const Subtitle = styled.p`
  color: ${primitives.color.gray11};
  font-weight: ${primitives.typography.weight2};
`;

export const Message = styled(divHTMLRender)`
  color: #5a5a5a;
  margin-top: 48px;
  font-weight: normal;

  > a {
    color: ${({ theme }) => theme.color.primary.base.default};
    text-decoration: underline;

    &:hover {
      color: ${({ theme }) => theme.color.primary.base.hover};
    }

    &:active {
      color: ${({ theme }) => theme.color.primary.base.active};
    }
  }
`;
